<p-panel
  [header]="header"
  [toggleable]="canToggle"
  [collapsed]="isCollapsed"
  [expandIcon]="expandIcon"
  [collapseIcon]="collapseIcon"
>
  <ng-content> </ng-content>
</p-panel>
